<script lang="ts">
	import britLogo from "@assets/images/brit-logo.svg";
	import nyroLogo from "@assets/images/nyro-logo.svg?raw";
	import Icon from "@components/common/Icon.svelte";
	import Media from "@components/common/Media.svelte";
	import { getTranslate } from "@utils/translate.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./Footer.translations.json" with { type: "json" };

	const { noMargin }: { noMargin?: boolean } = $props();

	const translate = getTranslate(translations);
	const { competition } = getGlobalTemplateProps();

	const payment = $derived(competition?.payment ?? null);

	const organizer = $derived(competition?.organizer ?? null);
	const contactName = $derived(organizer ? `${organizer.firstName} ${organizer.lastName}` : null);
</script>

<footer class={["grid-container relative bg-ink-950 text-white", { "mt-16": !noMargin }]}>
	<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-16 lg:gap-8 pt-20 py-16">
		<div class="flex flex-col gap-2">
			<strong class="mb-1 h3">{translate("headquarters")}</strong>
			<p class="text-sm font-semibold">DiscDog klub České republiky z.s.</p>
			<address class="text-sm">U Pergamenky 1511/3,<br />Holešovice 170 00 Praha 7</address>
			<p class="text-sm">IČ: 27040925</p>
			<p class="text-sm">DIČ: CZ27040925</p>
		</div>
		{#if payment}
			<div class="flex flex-col gap-2">
				<strong class="mb-1 h3">{translate("bank")}</strong>
				{#if payment.bankAccountNumber}
					<p class="text-sm">
						{translate("bankNumber")}: <span class="font-semibold">{payment.bankAccountNumber}</span>
					</p>
				{/if}
				{#if payment.iban}
					<p class="text-sm">IBAN: <span class="font-semibold">{payment.iban}</span></p>
				{/if}
				{#if payment.bic}
					<p class="text-sm">BIC/SWIFT: <span class="font-semibold">{payment.bic}</span></p>
				{/if}
				{#if payment.constantSymbol}
					<p class="text-sm">
						{translate("constantSymbol")}: <span class="font-semibold">{payment.constantSymbol}</span>
					</p>
				{/if}
				{#if payment.eurRate}
					<p class="text-sm">{translate("eurRate")}: <span class="font-semibold">{payment.eurRate}</span></p>
				{/if}
			</div>
		{/if}

		{#if organizer}
			<div class="flex flex-col gap-2">
				<strong class="mb-1 h3">{translate("contactUs")}</strong>
				{#if contactName}
					<p class="text-sm font-semibold">{contactName}</p>
				{/if}
				{#if organizer.phone}
					<p class="text-sm">
						{translate("phone")}:
						<a href="tel:{organizer.phone}" class="font-semibold hover:underline">{organizer.phone}</a>
					</p>
				{/if}
				<p class="text-sm">
					{translate("email")}:
					<a href="mailto:{organizer.email}" class="font-semibold hover:underline">{organizer.email}</a>
				</p>
				{#if organizer.fbEventUrl}
					<p class="text-sm">
						<a
							href={organizer.fbEventUrl}
							class="font-semibold hover:underline"
							target="_blank"
							rel="noopener noreferrer">{translate("facebook")}</a
						>
					</p>
				{/if}
				{#if organizer.webUrl}
					<p class="text-sm">
						<a href={organizer.webUrl} class="font-semibold hover:underline" target="_blank" rel="noopener noreferrer"
							>{translate("web")}</a
						>
					</p>
				{/if}
			</div>
		{/if}
		<div class="flex flex-col gap-2">
			<div class="rounded-md bg-white px-6 py-4 w-fit max-w-72">
				<Media
					class="max-md:w-32 max-w-48"
					source={{ src: britLogo, type: "image/svg+xml" }}
					width={474}
					height={422}
					alt="DiscDog Club logo"
				></Media>
				<p class="text-xs max-w-44 mt-3 leading-normal text-black">{translate("partner")}</p>
			</div>
		</div>
	</div>
	<div class="full-width grid-container pt-8 pb-20 text-sm text-center bg-ink-950 text-white">
		<div class="flex flex-col items-center gap-2">
			<Icon icon={nyroLogo} class="h-24 text-white" />
			<div>Developed with ❤️ by Nyro</div>
			<div>&copy; 2025</div>
		</div>
	</div>
</footer>
